import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createOrderLineAsync, deleteOrderLineAsync, getAllArticalsAsync, getAllOrderLineByOrderIdAsync, getArticalByIdAsync, getOrderLineByIDAsync, getWorkOrdersListWithClientAsync, recievedAllOrderLinesAsync, removeWorkOrderIdLinkedWithOrderLinesAsync, updateBulkOrderLineAsync, updateOrderLineAsync } from './orderLineThunk';
const initialState = {
    status: APIStatus.IDLE,
};
export const orderLineSlice = createSlice({
    name: 'orderline',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllArticalsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllArticalsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Articles = action.payload;
            state.ArticlesDropDown = action.payload.map((article) => {
                return {
                    label: `${article.articleNumber + ' - ' + article.name}`,
                    value: article.id
                };
            });
        })
            .addCase(getAllArticalsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getArticalByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getArticalByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Article = action.payload;
        })
            .addCase(getArticalByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkOrdersListWithClientAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkOrdersListWithClientAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.WorkOrderListWithClientOptions = action.payload.map((workOrder) => {
                return {
                    label: workOrder.workOrderNumber,
                    value: workOrder.id
                };
            });
        })
            .addCase(getWorkOrdersListWithClientAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createOrderLineAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createOrderLineAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderLine = action.payload;
        })
            .addCase(createOrderLineAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateOrderLineAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateOrderLineAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateOrderLine = action.payload;
        })
            .addCase(updateOrderLineAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllOrderLineByOrderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllOrderLineByOrderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderLines = action.payload;
        })
            .addCase(getAllOrderLineByOrderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getOrderLineByIDAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getOrderLineByIDAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderLine = action.payload;
        })
            .addCase(getOrderLineByIDAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteOrderLineAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteOrderLineAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteOrderLineAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(recievedAllOrderLinesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(recievedAllOrderLinesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderLines = action.payload;
        })
            .addCase(recievedAllOrderLinesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(removeWorkOrderIdLinkedWithOrderLinesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(removeWorkOrderIdLinkedWithOrderLinesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderLinesWithRemovedWorkOrders = action.payload;
        })
            .addCase(removeWorkOrderIdLinkedWithOrderLinesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateBulkOrderLineAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateBulkOrderLineAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateBulkOrderLineAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default orderLineSlice.reducer;
